import { Card } from 'antd';
import { Text } from '../Text';
import styled from 'styled-components';
import PlaceHolderImage from './assets/Image.svg';
import IcHot from './assets/Vector.svg';

interface ProductItemProps {
    title: string;
    subTitle?: string;
    imageUrl?: string;
    onClick?: () => void;
    className?: string;
    value?: number;
    price: string;
    isHot?: boolean;
}

const StyledCard = styled(Card)`
    width: 197px;
    padding: 8px;
    border-radius: 8px;
    background: #FFF;
    box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.15), 0px -3px 0px 0px #D6D6E7 inset;

    .ant-card-body {
        width: 100%;
        padding: 0px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
`;

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
`;

const StyledImage = styled.div`
    display: flex;
    padding: 8px 0px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    border-radius: 4px;
    background: #F5F5F5;
    position: relative;

    .fzt-image-product {
        width: 142px;
        height: 142px;
        border-radius: 5px;
    }
    
    .fzt-value {
        width: 40px;
        height: 40px;
        flex-shrink: 0;
        border-radius: 3px;
        background: #232F3E;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1;
    }
    
    .fzt-hot {
        width: 40px;
        height: 40px;
        border-radius: 4px;
        background: #FFFFFF;
        position: absolute;
        top: 3px;
        left: 3px;
        z-index: 1;
    }
`;

const Content = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-self: stretch;

    .content_text {
        display: flex;
        flex-direction: column;
        gap: 2px;
        align-self: stretch;
    }
    .fzt-subtitle {
        font-style: italic;
    }
`;

const ProductItem: React.FC<ProductItemProps> = ({ title, subTitle, imageUrl, value, onClick, className, price, isHot }) => {
    return (
        <StyledCard className={className} onClick={onClick}>
            <Container>
                <StyledImage>
                    {
                        value && 
                        (
                            <div className="fzt-value">
                                <Text title_h5 semibold color='neutral.text.1' center>{value}</Text>
                            </div>
                        )
                    }  

                    {
                        isHot &&
                        (
                            <div className="fzt-hot">
                                <img src={IcHot} alt="hot"/>
                            </div>                        
                        )
                    }             
                    <img src={imageUrl || PlaceHolderImage} alt={title} className="fzt-image-product"/>
                </StyledImage>
                <Content>
                    <div className="content_text">
                        <Text title_h6 regular left color='neutral.text.5'>{title}</Text>
                        <Text content_1 regular color='neutral.text.4' left className="fzt-subtitle">{subTitle}</Text>
                    </div>
                    <Text title_h7 semibold color='neutral.text.5' left>${price}</Text>
                </Content> 
            </Container>
        </StyledCard>
    );
};

export default ProductItem;
